import React from "react"
import cx from "classnames"

export type PlateNumberPropsType = React.PropsWithChildren<{
  className?: string
}>

export const PlateNumber = ({ children, className }: PlateNumberPropsType) => (
  <div className={cx("cobalt-plate-number", className)}>{children}</div>
)
